<template>
  <v-tabs-items v-bind="$attrs" :value="value" @change="$emit('change', $event)">
    <slot />
  </v-tabs-items>
</template>

<script>
import {VTabsItems} from "vuetify/lib/components";

export default {
  name: "XTabItems",
  extends: VTabsItems,
  props: ['value'],

  watch: {}
}
</script>

<style scoped>

</style>
